import React from 'react';
import Label from '@teetsh/app/src/components/Form/Label';
import DateInput2 from '@teetsh/app/src/components/Form/Dateinput2';
import tw from 'twin.macro';
import { css } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import { UserLocale } from '@teetsh/app/src/types/user';

export interface IDateRange {
  from?: Date;
  to?: Date;
}

interface Props {
  id: string;
  value: IDateRange;
  onChange: (v: IDateRange) => void;
  fixedWeeks?: boolean;
}

export function DateRange(props: Props) {
  const { value, onChange, id, fixedWeeks } = props;
  const { t } = useTranslation(['common']);
  return (
    <div tw="flex gap-x-4 gap-y-2 flex-wrap">
      <div
        css={[
          tw`flex items-center`,
          css`
            max-width: 9rem;
          `,
        ]}
      >
        <Label id={`from-${id}`} tw="mr-1">
          {t('common:components.dateRange.from')}
        </Label>
        <DateInput2
          userLocale={t('common:locale.long') as UserLocale}
          id={`from-${id}`}
          onChange={v => v && onChange({ ...value, from: v })}
          value={value.from}
          fixedWeeks={fixedWeeks}
        />
      </div>
      <div
        css={[
          tw`flex items-center`,
          css`
            max-width: 9rem;
          `,
        ]}
      >
        <Label id={`to-${id}`} tw="mr-1">
          {t('common:components.dateRange.to')}
        </Label>
        <DateInput2
          id={`to-${id}`}
          userLocale={t('common:locale.long') as UserLocale}
          onChange={v => v && onChange({ ...value, to: v })}
          value={value.to}
          fixedWeeks={fixedWeeks}
        />
      </div>
    </div>
  );
}
